import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SessionQuery } from '../session';
import { AssetState, AssetStore } from './asset.store';

@Injectable({ providedIn: 'root' })
export class AssetQuery extends QueryEntity<AssetState> {
	constructor(protected override store: AssetStore) {
		super(store);
	}
}
